import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { CATEGORIES } from '@/data/products';

// Showcases the user-provided range posters (5 product range hero images)
// as the "Our Ranges" strip. This brings the actual brand photography front-and-center.
export default function RangeShowcase() {
  return (
    <section className="container-x py-20" data-testid="range-showcase">
      <div className="flex items-end justify-between gap-6 mb-10">
        <div>
          <span className="eyebrow">Our Ranges</span>
          <h2 className="font-display text-4xl lg:text-5xl text-bone-50 mt-3 tracking-tight">
            Five ranges. <span className="italic text-sage-300">One theory.</span>
          </h2>
        </div>
        <Link to="/shop" className="hidden md:inline-flex btn-outline !py-2.5 !px-5">
          See all <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {CATEGORIES.map((cat, idx) => (
          <Link
            key={cat.slug}
            to={`/shop?cat=${cat.slug}`}
            data-testid={`range-${cat.slug}`}
            className={`group relative overflow-hidden rounded-3xl border border-bone-100/8 hover:border-gold/40 transition-all duration-500 ${idx === 0 ? 'lg:row-span-2 aspect-[3/4] lg:aspect-auto' : 'aspect-[4/5]'}`}
          >
            <img
              src={cat.heroImage}
              alt={cat.name}
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ink-950 via-ink-950/30 to-transparent" />
            <div className="absolute inset-0 bg-gradient-to-br from-transparent via-transparent to-ink-950/60" />
            <div className="absolute inset-0 p-6 lg:p-8 flex flex-col justify-end">
              <span className="text-[10px] tracking-[0.32em] uppercase text-gold/90">{cat.tagline}</span>
              <h3 className="font-display text-2xl lg:text-3xl text-bone-50 mt-2">{cat.name}</h3>
              <span className="mt-4 inline-flex items-center gap-2 text-sm text-bone-100 group-hover:text-gold transition-colors">
                Explore the range <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
